import {
    useLayoutEffect,
    useRef,
    useState,
    useEffect,
    useContext
} from 'react';
import '../../asset/styles/top-bar-container-style.css';
import { useLocation, useNavigate } from 'react-router-dom';
import sidebarSource from '../nav-config';
import { Dropdown, Menu } from 'antd';


import {
    targetOptions
} from '../../../constants/page-control';

import {useLocalStorageListener,getUserDetail } from '../../../hooks/handleUserLocalStorage';


interface Props {
    show?: boolean;
}

const Index = (props: Props) => {
    const location = useLocation();
    // const [cookies, setCookie, removeCookie] = useCookies(['user']);
    const [sidebarProps, setSidebarProps] = useState(sidebarSource);

    useEffect(() => {
        handleSiderbarProps();
    }, []);

    useEffect(() => {
        let lastSegment = location.pathname;
        initSideOptions(sidebarSource, lastSegment);
    }, [location]);

    // useEffect(() => {
    //     //check if logined
    //     if (cookies.user) {
    //         if (cookies.user.user) {
               
    //         }
    //     }
    // }, [cookies]);

    // useLocalStorageListener((localdata) => {
    //     let localUser = getUserDetail();
    //     if (localUser) {
    //         if (localUser.user) {
    //             setIsModalOpen(localUser.user?.reset_password_mode);
    //         }
    //     }
    // });

    const initSideOptions = (data: any, lastSegment: String) => {
        let foundPage = false;
        let newArr: any = [];

        //check selected option and highlight it
        for (var i = 0; i < sidebarSource.length; i++) {
            let row = data[i];
            data[i].selected = false;
            if (row.url == lastSegment) {
                data[i].selected = true;
                foundPage = true;
            }

            if (row.subMenu && row.subMenu.length > 0) {
                //check submenu data
                for (var z = 0; z < row.subMenu.length; z++) {
                    //default set to false;
                    data[i].subMenu[z].selected = false;

                    let innerRow = row.subMenu[z];
                    if (innerRow.url == lastSegment) {
                        //selected submenu option
                        data[i].subMenu[z].selected = true;
                        //selected parent option
                        data[i].selected = true;

                        foundPage = true;
                    }
                }
            }

            newArr.push(row);
        }

        if (foundPage == false && data.length > 0) {
            data[0].selected = true;
        }

        //check permission
        let newMenu = handleSiderbarProps();
        if(newMenu){
            newArr = newMenu;
        }
        setSidebarProps(newArr);
    };

    const handleSiderbarProps = () => {

        let localUser = getUserDetail();
       // console.log("localUser123 ",localUser)
        if(localUser?.tools){   
           // console.log("handleSiderbarProps cookies.user ",cookies.user.tools);

            //check permission
            let newMenu = getNewMenuWithPermission(localUser.tools);
            return newMenu;
           // setSidebarProps(newMenu);
        }

        return false;
    }


    //check page permission and return available menu
    const getNewMenuWithPermission = (tools:any) => {
   // console.log("tools123 ",tools)

        let menuOptions = [...sidebarSource]
        const validIds = targetOptions;//valid parent menu id to check

        //check parent menu match with tools permission
        let newMenuOptions = menuOptions.filter((row:any,i:number)=>{
            if (validIds.includes(row.id)) {

                let keyExist = tools.hasOwnProperty(row.id);
                if(!keyExist) // not permission item exist
                    return true;

                //start check
                if(tools[row.id]){
                    return true;
                }else{
                    return false;
                }
            }

            return true;
          
        });


        //check sub menu match with tools permission
        let newToolsMenu = newMenuOptions.map((row:any,i:number)=>{
            
              if (validIds.includes(row.id)) {
                if(!row.subMenu) return row;

                //use filter
                let newSubMenu = row.subMenu.filter((subRow:any,i:number)=>{
                    if(!subRow.id){
                        return true;
                    }
                    if(tools[subRow.id]){
                        return true;
                    }else{
                        return false;
                    }
                });
                // let newSubMenu = row.subMenu.map((subRow:any,i:number)=>{
                //     if(!subRow.id){
                //         return subRow;
                //     }
                //     console.log("subRow.id",subRow.id,tools[subRow.id])
                //     if(tools[subRow.id]){
                //         //remain
                //     }else{
                //         //remove whole object
                //         delete subRow;
                      
                //     }
                //     return subRow;
                // })
                row.subMenu = newSubMenu;
            }
            return row;
        })
      //console.log("newToolsMenu",newToolsMenu)
        return newToolsMenu;
    }

    return (
        <div className='reverse-scrollbar-container'>
            {props.show != false ? (
                <div className="top-nav-container">
                    <ul className="top-nav-navbar">
                        {sidebarProps.map(function (row, i) {
                            let className = '';
                            if (row.selected == true) className = ' active';

                            let compt = <TopMenuItem row={row} key={i} />;
                  
                            return compt;
                        })}
                    </ul>
                </div>
            ) : null}
        </div>
    );
};

const TopMenuItem = (props: any) => {
    const location = useLocation();
    const itemRef = useRef<any>();
    let navigate = useNavigate();
    let row = props.row;
    let className = '';
    if (row.selected == true) className = ' active';

    const [itemPosition, setItemPosition] = useState<any>({});

    //check main or sub page to decide redirect
    const redirect = async (row: any) => {
        let url = row.url;
        let label = row.label;
        let openNewTab = row.openNewTab;

        let currentPage = location.pathname;
        if (url) {
            //open new tab with unique
            let currentPageProps:any = getCurrentPageConfig(currentPage);
           // console.log("currentPageProps",currentPageProps)
            let stayPageWhenRedirect = currentPageProps?.stayPageWhenRedirect;
         // console.log("jump ",row)
            if(openNewTab){
                let targetName = row.targetName || "_blank"
                let features = row.features||null;

                if(features){
                    window.open(url,targetName, features);
                }else{
                    window.open(url,targetName);
                }
            

                if (newTab) {
                    newTab.focus();
                }
            }else
            if(stayPageWhenRedirect){
                const newTab = window.open(url,"subTab");
                if (newTab) {
                    newTab.focus();
                }
            }else{
                let state = currentPageProps?.state||{};
                navigate(url, { state: state });
            }
           
          
        }
    };

    const getCurrentPageConfig = ( currentPage: String) => {
        let data = sidebarSource;
        let currentPageProps = null;
        for (var i = 0; i < data.length; i++) {
            let row = data[i];
            if (row.url == currentPage) {
                currentPageProps = row;
                break;
            }

            if (row.subMenu && row.subMenu.length > 0) {
                for (var z = 0; z < row.subMenu.length; z++) {
                    let innerRow = row.subMenu[z];
                    if (innerRow.url == currentPage) {
                        currentPageProps = innerRow;
                        break;
                    }
                }
            }
        }
        return currentPageProps;
    }

    useEffect(() => {
        if (itemRef.current && row.subMenu) {
            let bound = itemRef.current.getBoundingClientRect();
            setItemPosition(bound);
        }
    }, []);

    // resize listener
    useLayoutEffect(() => {
        function updateSize() {
            let bound = itemRef.current.getBoundingClientRect();
            setItemPosition(bound);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

  
    const handleSubMenu =(row:any)=>{
        if(!row.subMenu) return<></>;
        let MenuItems:any = []
        let selectedKeys:any = []
        row.subMenu.map(function (row:any, i:number) {
            if(row.selected){
                selectedKeys.push(row.url)
            }
            MenuItems.push(<Menu.Item key={row.url} onClick={(e) => redirect(row)}>{row.label}</Menu.Item>)
        })
        return <>
            <Menu selectedKeys={selectedKeys}>
                {MenuItems}
              
                {/* <Menu.Item>item 2</Menu.Item> */}
            </Menu>
            </>
    }
    return (
        <li className={" bar-li "+className} >
            <div className="item" ref={itemRef}>
                <div className="item-content" style={{
                    zIndex:1
                }}>
                    
                    <Dropdown overlay={handleSubMenu(row)}>
                        <div className="item-text d-flex align-items-center justify-content-center" onClick={(e) => redirect(row)}>
                            <img src={row.icon} /> 
                            &nbsp;
                            {row.label}
                        </div>
                    </Dropdown>
                </div>
       
            </div>
            {/* <div className='rec-back'></div> */}
        </li>
    );
};

export default Index;
